<div class="content-wrapper container-xxl p-0">
    <div class="content-body">
        <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-6 col- col-12">
                <app-content-header [contentHeader]="contentHeader"></app-content-header>
            </div>
        </div>

        <div class="card">
            <div class="card-title w-100 p-1">
                <div class="row">
                    <ngb-alert [type]="'danger'" [dismissible]="false" class="card m-1 w-100 m-0 active" *ngIf="errorEmailNotSendedUsers && errorEmailNotSendedUsers.length > 0">
                        <h4 class="alert-heading py-1">
                            {{ "STATUS.ERROR" | translate }}
                        </h4>
                        <section class="px-1" class="alert-body">
                            <p>{{ "EMAIL_NOT_SENDED_FOR_THESE_USERS" | translate }}</p>
                            <ul>
                                <li *ngFor="let user of errorEmailNotSendedUsers">{{ user }}</li>
                            </ul>
                        </section>
                    </ngb-alert>
                    <div ngClass.sm="col-12 mb-1" ngClass.md="col-12 mb-1" ngClass.xl="col-3">
                        <label for="search" class="d-flex align-items-center mb-0">
                            <input [(ngModel)]="searchKeyword" (ngModelChange)="filterUsers()" type="search" class="form-control" id="search" [placeholder]="'SEARCH_USER' | translate"/>
                        </label>
                    </div>
                    <div ngClass.sm="col-12 mb-1" ngClass.md="col-12 mb-1" ngClass.xl="col-3">
                        <label class="d-flex align-items-center mb-0">
                            <select [(ngModel)]="selectedCategory" (ngModelChange)="filterUsers()" class="form-control">
                                <option *ngFor="let category of categories">{{ category }}</option>
                            </select>
                        </label>
                    </div>
                    <div ngClass.xl="d-flex align-items-center" ngClass.md="col-12 d-flex" ngClass.sm="mx-1 mb-1" *ngIf="emailToSend">
                        <button
                                (click)="selectAllUsers(true)"
                                *ngIf="emailToSend && emailToSend.length > 0 && emailToSend.length !== userList.length"
                                type="button"
                                class="btn btn-outline-primary"
                                ngClass.sm="col-12 mb-1"
                                ngClass.md="m-1"
                                ngClass.xl="ml-1"
                        >
                            {{ "SELECT_ALL_MALE" | translate }}
                        </button>
                        <button
                                (click)="selectAllUsers(false)"
                                *ngIf="emailToSend && emailToSend.length > 0 && userList && userList.length > 0 && emailToSend.length === userList.length"
                                type="button"
                                class="btn btn-outline-primary"
                                ngClass.sm="col-12 mb-1"
                                ngClass.md="mr-1 my-1"
                        >
                            {{ "DESELECT_ALL_MALE" | translate }}
                        </button>
                        <button (click)="sendEmailToUsers()" *ngIf="emailToSend && emailToSend.length > 0" type="button" class="btn btn-outline-primary" ngClass.xl="ml-1" ngClass.sm="col-12" ngClass.md="my-1">
                            {{ "SEND_WELCOME_EMAIL_MULTIPLE" | translate }}
                        </button>
                    </div>
                </div>
            </div>
            <div class="border-top py-1" *ngIf="!filteredUsers || filteredUsers.length < 1">
                <div class="font-medium-1">{{ "NO_USERS_FOR_ONBOARDING" | translate }}</div>
            </div>
            <div class="row mx-1">
                <div class="flex-basis-2">&nbsp;</div>
                <div class="flex-basis-35">
                    <span class="font-weight-bold">{{ "NAME" | translate }}</span>
                </div>
                <div class="flex-basis-40">
                    <span class="font-weight-bold">{{ "EMAIL" | translate }}</span>
                </div>
            </div>

            <div *ngIf="filteredUsers && filteredUsers.length > 0">
                <div
                        class="{{ index !== 0 ? 'border-top' : '' }} p-1"
                        [ngClass]="emailToSend.includes(user.hash) ? 'user-checked' : ''"
                        [id]="'user-' + user.hash"
                        *ngFor="let user of filteredUsers | slice: (pageBasicText - 1) * pageSize : pageBasicText * pageSize; let index = index"
                >
                    <div class="row px-1">
                        <div class="flex-basis-2 custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input todo-checkbox" id="customCheck{{ user.hash }}" [checked]="emailToSend.includes(user.hash)" (click)="toggleEmailToSend(user.hash)"/>
                            <label class="custom-control-label" for="customCheck{{ user.hash }}"></label>
                        </div>
                        <div class="flex-basis-35">
                            <span class="mb-025 font-medium-1">{{ user.complete_name }}</span>
                        </div>
                        <div class="flex-basis-40">
                            <span class="mb-025 font-medium-1" *ngIf="user.email || user.private_email">{{ selectedCategory === "Email privata" ? user.private_email : user.email }}</span>
                            <span class="mb-025 font-medium-1" *ngIf="!user.private_email && user.email">{{ "NOT_HAS_PRIVATE_EMAIL" }}</span>
                            <span class="mb-025 font-medium-1" *ngIf="!user.email && !user.private_email">{{ "NOT_HAS_COMPANY_EMAIL" }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12 d-flex" ngClass.xl="justify-content-end" ngClass.sm="justify-content-center" ngClass.md="justify-content-center">
                <ngb-pagination
                        [pageSize]="pageSize"
                        [collectionSize]="filteredUsers.length"
                        [(page)]="pageBasicText"
                        [ellipses]="false"
                        *ngIf="filteredUsers && filteredUsers.length > 0"
                        aria-label="Custom pagination"
                        [maxSize]="5"
                >
                    <ng-template ngbPaginationPrevious><span [data-feather]="'chevron-left'" [size]="'18'" [class]="'font-weight-bolder page-item'"></span></ng-template>
                    <ng-template ngbPaginationNext><span [data-feather]="'chevron-right'" [size]="'18'" [class]="'font-weight-bolder page-item'"></span></ng-template>
                </ngb-pagination>
            </div>
        </div>
    </div>
</div>
